import React from "react";
import LegalLayout, { Section } from "./LegalLayout";

export default function AGBPage() {
  return (
    <LegalLayout
      title="Allgemeine Geschäftsbedingungen (AGB)"
      lastUpdated="16.05.2026"
      testId="agb-page"
    >
      <Section title="1. Geltungsbereich">
        <p>
          Diese Allgemeinen Geschäftsbedingungen (nachfolgend „AGB") regeln das
          Nutzungsverhältnis zwischen StudioOps (Silverio Cosenza,
          Amalienstraße 57/16, 1130 Wien, Österreich; nachfolgend „Anbieter")
          und dem gewerblichen Kunden (nachfolgend „Kunde") über die Nutzung
          der SaaS-Plattform StudioOps Food. Die AGB richten sich
          ausschließlich an Unternehmer im Sinne des § 1 KSchG. Verbraucher
          sind ausgeschlossen.
        </p>
      </Section>

      <Section title="2. Vertragsgegenstand">
        <p>
          Der Anbieter stellt dem Kunden eine cloudbasierte Software zur
          Kalkulation von F&amp;B-Kosten, zur Erstellung von Rezepten und
          Speisekarten sowie zur KI-gestützten Rezeptgenerierung zur Verfügung.
          Der konkrete Funktionsumfang richtet sich nach dem vom Kunden
          gewählten Tarif (Küche, Bar, Pro, Hotel, Premium).
        </p>
      </Section>

      <Section title="3. Vertragsabschluss">
        <p>
          Der Vertrag kommt durch erfolgreiche Auswahl eines Tarifs auf der
          Website, vollständige Bezahlung über Stripe und automatische
          Account-Erstellung zustande. Mit dem Abschluss bestätigt der Kunde,
          diese AGB sowie die Datenschutzerklärung gelesen und akzeptiert zu
          haben.
        </p>
      </Section>

      <Section title="4. Laufzeit & Kündigung">
        <ul className="list-disc pl-5 space-y-1.5">
          <li>
            <strong>Monatsabonnement:</strong> Die Mindestvertragslaufzeit
            beträgt einen Monat. Eine ordentliche Kündigung ist mit einer Frist
            von <strong>28 Tagen</strong> zum Ende des laufenden
            Abrechnungszeitraums möglich.
          </li>
          <li>
            <strong>Jahresabonnement:</strong> Die Mindestvertragslaufzeit
            beträgt zwölf Monate. Die Kündigung ist zum Ende der Laufzeit
            möglich. Eine{" "}
            <strong>Rückerstattung für bereits bezahlte Jahresabonnements ist ausgeschlossen</strong>
            ; das gilt auch bei vorzeitiger Beendigung durch den Kunden.
          </li>
          <li>
            Die Kündigung erfolgt direkt aus dem Account (Bereich „Abo &amp;
            Rechnung") oder schriftlich per E-Mail an{" "}
            <a href="mailto:hello@studioops.io" className="text-brand hover:underline">
              hello@studioops.io
            </a>
            .
          </li>
          <li>
            Das Recht zur außerordentlichen Kündigung aus wichtigem Grund
            bleibt für beide Seiten unberührt.
          </li>
        </ul>
      </Section>

      <Section title="5. Preise & Zahlungsbedingungen">
        <ul className="list-disc pl-5 space-y-1.5">
          <li>
            Es gelten die zum Zeitpunkt des Vertragsabschlusses auf der Website
            ausgewiesenen Preise. Alle Preise verstehen sich netto, zuzüglich
            der jeweils gesetzlichen Umsatzsteuer (AT 20 %, DE 19 %, CH 7,7 %).
          </li>
          <li>
            Die Abrechnung erfolgt ausschließlich über den Zahlungsdienstleister{" "}
            <strong>Stripe Payments Europe Ltd.</strong> per
            Kreditkarte, SEPA-Lastschrift oder weiteren von Stripe angebotenen
            Methoden.
          </li>
          <li>
            Die Rechnung wird elektronisch (PDF) bereitgestellt. Der Kunde
            erklärt sich mit der elektronischen Rechnungslegung einverstanden.
          </li>
          <li>
            Bei Zahlungsverzug ist der Anbieter berechtigt, den Zugang zur
            Plattform nach vorheriger E-Mail-Mahnung zu sperren. Verzugszinsen
            werden in gesetzlicher Höhe verrechnet.
          </li>
        </ul>
      </Section>

      <Section title="6. Pflichten des Kunden">
        <p>
          Der Kunde ist verpflichtet, Zugangsdaten geheim zu halten,
          eingegebene Inhalte (Rezepte, Speisekarten, Kundendaten in
          Catering-Rechnungen) rechtskonform zu nutzen und keine
          rechtswidrigen oder rechtsverletzenden Inhalte zu speichern.
        </p>
      </Section>

      <Section title="7. Verfügbarkeit & Wartung">
        <p>
          Der Anbieter ist um eine Verfügbarkeit der Plattform von 99 % im
          Jahresmittel bemüht. Geplante Wartungsarbeiten werden nach
          Möglichkeit außerhalb üblicher Geschäftszeiten durchgeführt. Eine
          darüberhinausgehende Verfügbarkeitsgarantie wird nicht
          übernommen.
        </p>
      </Section>

      <Section title="8. KI-Funktionen (Claude)">
        <p>
          Die KI-gestützten Rezept- und Cocktail-Vorschläge werden durch
          Anthropic Claude erzeugt. Der Anbieter übernimmt keine Garantie für
          Richtigkeit, Vollständigkeit oder Verkehrsfähigkeit der vorgeschlagenen
          Rezepturen. Allergen-, Zoll- und Hygienevorschriften sind vom Kunden
          eigenverantwortlich zu prüfen.
        </p>
      </Section>

      <Section title="9. Haftung">
        <p>
          Der Anbieter haftet nur für Schäden, die auf grober Fahrlässigkeit
          oder Vorsatz beruhen. Die Haftung für leichte Fahrlässigkeit, für
          Folgeschäden, entgangenen Gewinn und Datenverluste ist – soweit
          gesetzlich zulässig – ausgeschlossen. Insgesamt ist die Haftung
          summenmäßig auf das vom Kunden in den letzten 12 Monaten gezahlte
          Entgelt begrenzt.
        </p>
      </Section>

      <Section title="10. Datenschutz">
        <p>
          Es gilt unsere{" "}
          <a href="/datenschutz" className="text-brand hover:underline">
            Datenschutzerklärung
          </a>
          . Soweit der Kunde im Rahmen der Plattform personenbezogene Daten
          Dritter verarbeitet, schließen die Parteien einen separaten
          Auftragsverarbeitungsvertrag (AVV) gemäß Art. 28 DSGVO ab. Eine
          Vorlage stellt der Anbieter im Bereich „Einstellungen → Rechtliches"
          bereit.
        </p>
      </Section>

      <Section title="11. Änderungen der AGB">
        <p>
          Der Anbieter ist berechtigt, diese AGB mit angemessener Ankündigungsfrist
          (mindestens 30 Tage per E-Mail) anzupassen. Widerspricht der Kunde
          den Änderungen nicht innerhalb dieser Frist, gelten sie als
          akzeptiert. Im Widerspruchsfall steht dem Kunden ein
          Sonderkündigungsrecht zum Inkrafttreten der Änderungen zu.
        </p>
      </Section>

      <Section title="12. Anwendbares Recht & Gerichtsstand">
        <p>
          Es gilt ausschließlich <strong>österreichisches Recht</strong> unter
          Ausschluss des UN-Kaufrechts und der kollisionsrechtlichen
          Verweisungsnormen. Ausschließlicher Gerichtsstand für alle
          Streitigkeiten aus diesem Vertragsverhältnis ist das sachlich
          zuständige Gericht in <strong>1130 Wien, Österreich</strong>.
        </p>
      </Section>

      <Section title="13. Schlussbestimmungen">
        <p>
          Sollten einzelne Bestimmungen dieser AGB unwirksam sein, bleibt die
          Wirksamkeit der übrigen Bestimmungen unberührt. An die Stelle der
          unwirksamen Bestimmung tritt eine wirksame Regelung, die dem
          wirtschaftlichen Zweck der unwirksamen Bestimmung am nächsten kommt.
        </p>
      </Section>
    </LegalLayout>
  );
}
